export enum FileTypes {
    mp4 = "video/mp4",
    webm = "video/webm",
    jpg = "image/jpeg",
    png = "image/png",
    webp = "image/webp",
}
